import React from 'react';
import Icon from '../../../components/AppIcon';

const AnnouncementFilters = ({ activeFilter, onFilterChange }) => {
  const filters = [
    { id: 'all', label: 'All Announcements', icon: 'MessageSquare' },
    { id: 'raids', label: 'Raids', icon: 'Swords' },
    { id: 'events', label: 'Events', icon: 'Calendar' },
    { id: 'updates', label: 'Updates', icon: 'Bell' },
    { id: 'recruitment', label: 'Recruitment', icon: 'UserPlus' }
  ];

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 mb-6">
      {filters?.map((filter) => (
        <button
          key={filter?.id}
          onClick={() => onFilterChange(filter?.id)}
          className={`flex items-center gap-2 px-4 py-2 rounded-xl font-medium text-sm transition-base flex-shrink-0 ${
            activeFilter === filter?.id
              ? 'bg-primary text-primary-foreground shadow-warm'
              : 'bg-muted text-muted-foreground hover:bg-card'
          }`}
        >
          <Icon name={filter?.icon} size={16} />
          <span className="whitespace-nowrap">{filter?.label}</span>
        </button>
      ))}
    </div>
  );
};

export default AnnouncementFilters;